var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoFullLight = function SvgLogoFullLight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123,
    height: 16,
    fill: "none",
    viewBox: "0 0 123 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_radial_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_radial_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_radial_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_radial_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_radial_5846_30697)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E130E",
    d: "M78 3.595c-.03.177.178.29.311.172.768-.687 2.218-.953 2.859-.986.64-.034 1.502-.033 1.502-.033.254 0 .462.206.462.461v.814c0 .152.124.276.276.276h.993a.277.277 0 0 0 .277-.276v-1.09c0-.102.083-.185.184-.185h1.18c.103 0 .185.083.185.184l.002.001v1.182a.185.185 0 0 1-.184.184h-1.089a.277.277 0 0 0-.276.277v1c0 .152.123.276.276.276h.811c.255 0 .462.207.462.462v2.415a.46.46 0 0 1-.462.462h-.811a.277.277 0 0 0-.276.277v.818a.46.46 0 0 1-.462.462h-.809a.277.277 0 0 0-.276.277v.806a.46.46 0 0 1-.462.462s-.691.03-1.497-.018c-1.25-.076-2.205-.469-3.03-1.111v4.566h-1.663V2.747h1.662zm-31.848-.902c2.696 0 4.49 1.775 4.49 4.544 0 .24-.01.484-.044.731H43.41v.035c.055 1.765 1.166 2.906 2.832 2.906 1.3 0 2.252-.68 2.544-1.82l.019-.07h1.692l-.021.11c-.393 2-2.011 3.291-4.124 3.291-2.806 0-4.69-1.943-4.69-4.835 0-1.405.43-2.612 1.242-3.489.814-.881 1.937-1.403 3.246-1.403zm24.807 0c2.695 0 4.488 1.776 4.488 4.545 0 .24-.01.484-.044.731h-7.188v.035c.055 1.764 1.167 2.906 2.833 2.906 1.3 0 2.251-.68 2.544-1.82l.017-.07h1.693l-.022.11c-.392 2-2.01 3.29-4.124 3.29-2.804 0-4.688-1.942-4.688-4.834 0-1.405.43-2.612 1.242-3.489v-.002c.816-.88 1.938-1.402 3.248-1.402m-9.461 0c2.252 0 3.775 1.29 4.178 3.438l.02.11h-1.748l-.015-.072c-.268-1.211-1.162-1.965-2.454-1.965-1.726 0-2.886 1.422-2.886 3.399 0 1.976 1.16 3.304 2.885 3.305 1.237 0 2.147-.7 2.435-1.873l.018-.07h1.763l-.02.109c-.38 2.094-1.956 3.345-4.213 3.345-2.782 0-4.58-1.89-4.58-4.816 0-1.414.442-2.627 1.28-3.507s1.991-1.403 3.337-1.403M90.708.845c.102 0 .186.083.186.185v1.535c0 .101.083.185.184.185h2.816c.101 0 .185.083.185.185v1.18a.186.186 0 0 1-.185.186h-2.816c-.1 0-.184.083-.184.185v5.992c0 .152.124.276.277.276l2.636.003a.277.277 0 0 0 .276-.276V9.386c0-.102.084-.185.186-.184l1.185.002c.1 0 .184.08.184.181v1.186a.186.186 0 0 1-.185.185H94.36a.277.277 0 0 0-.276.277v.818a.46.46 0 0 1-.462.462h-1.764v-.004h-.502a.46.46 0 0 1-.462-.462v-.818a.28.28 0 0 0-.277-.277h-1.092a.185.185 0 0 1-.184-.184V4.483a.185.185 0 0 0-.185-.185h-1.183a.185.185 0 0 1-.184-.184V2.932c0-.1.082-.184.184-.184h1.183c.101 0 .184-.082.185-.184V1.03c0-.101.082-.185.184-.185zm7.583 1.902c.102 0 .184.083.184.185v1.186c0 .1.084.184.185.184h1.092a.28.28 0 0 0 .277-.277v-.816c0-.255.208-.462.463-.462h2.459c.102 0 .186.082.186.184v1.186a.187.187 0 0 1-.186.185h-2.644a.277.277 0 0 0-.277.277v.812a.463.463 0 0 1-.463.463h-.907a.186.186 0 0 0-.184.185v6.088a.186.186 0 0 1-.185.186h-1.185a.186.186 0 0 1-.185-.186V2.932c0-.102.083-.185.185-.185zm12.556 0c.255 0 .462.206.463.462v.907c0 .102.082.185.184.185h1.15a.22.22 0 0 1 .219.22v6.02a.22.22 0 0 1-.219.22h-1.058a.276.276 0 0 0-.276.277v1.09a.187.187 0 0 1-.186.185h-5.189a.46.46 0 0 1-.461-.463v-.903a.187.187 0 0 0-.186-.186h-.906a.463.463 0 0 1-.463-.463V4.764c0-.255.207-.463.463-.463h.814a.28.28 0 0 0 .278-.276V2.93c0-.102.082-.184.184-.184zm4.925 0c.102 0 .186.082.186.184v1.184c0 .102.084.185.186.185h1.09a.28.28 0 0 0 .278-.276V2.932c0-.102.082-.185.184-.185h1.183c.102 0 .185.083.185.185v1.092a.28.28 0 0 0 .277.276h1.087c.123 0 .241.048.328.135l1.283 1.396a.47.47 0 0 1 .135.327v5.969a.187.187 0 0 1-.186.185h-1.184a.186.186 0 0 1-.185-.185V6.04a.186.186 0 0 0-.185-.186h-1.184a.187.187 0 0 1-.186-.186V4.575a.277.277 0 0 0-.276-.277h-.999a.277.277 0 0 0-.276.277v1.094a.187.187 0 0 1-.186.186h-1.183a.187.187 0 0 0-.186.186v6.086a.187.187 0 0 1-.186.185h-1.183a.186.186 0 0 1-.185-.185V2.931c0-.102.084-.184.186-.184zM37.319.27a3.95 3.95 0 0 1 3.947 3.947 3.95 3.95 0 0 1-3.947 3.947h-3.506v4.146H32.15L32.145.27zM53.172 3.6c-.03.168.174.272.295.15l-.001.001c.59-.594 1.395-1.004 2.156-1.004h.876v1.677h-.875a2.3 2.3 0 0 0-2.298 2.297v5.588h-1.664V2.747h1.664zm52.577.701a.276.276 0 0 0-.276.277v4.44c0 .102.082.185.184.186h.907c.256 0 .463.206.463.462v.91c0 .103.084.186.186.186h3.819a.28.28 0 0 0 .277-.276V6.042a.187.187 0 0 0-.186-.185h-.906a.464.464 0 0 1-.463-.463v-.907a.185.185 0 0 0-.184-.185h-3.821M81.111 4.3c-1.77.04-3.085 1.166-3.085 3.227 0 2.09 1.318 3.152 3.156 3.222.817.018 1.767 0 1.767 0a.185.185 0 0 0 .185-.184v-.911c0-.255.206-.462.462-.462h.807a.277.277 0 0 0 .277-.276V6.13a.28.28 0 0 0-.277-.277h-.807a.46.46 0 0 1-.462-.462v-.908a.185.185 0 0 0-.185-.185s-1.176-.034-1.838 0M46.17 4.185c-1.356 0-2.48 1.042-2.658 2.362h5.335c-.172-1.444-1.166-2.362-2.677-2.362m24.805 0c-1.355 0-2.48 1.042-2.658 2.362h5.336c-.172-1.445-1.166-2.362-2.678-2.362m-37.162-2.25V6.5h3.506l.001-.001a2.285 2.285 0 0 0 2.282-2.282 2.285 2.285 0 0 0-2.282-2.282z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5846_30697",
    x1: 21.842,
    x2: 25.485,
    y1: 4.533,
    y2: 2.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5846_30697",
    x1: 20.561,
    x2: 15.184,
    y1: 5.639,
    y2: 9.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5846_30697",
    x1: 10.753,
    x2: 7.959,
    y1: 12.196,
    y2: 9.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5846_30697",
    x1: 4.375,
    x2: 6.757,
    y1: 6.045,
    y2: 8.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5846_30697",
    x1: 4.375,
    x2: -2.171,
    y1: 6.045,
    y2: 0.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5846_30697",
    x1: 2.707,
    x2: -0.308,
    y1: 6.996,
    y2: 8.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5846_30697",
    x1: 9.016,
    x2: 6.002,
    y1: 8.525,
    y2: 5.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5846_30697",
    x1: 20.853,
    x2: 19.354,
    y1: 2.688,
    y2: 3.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5846_30697",
    x1: 21.781,
    x2: 20.327,
    y1: 4.4,
    y2: 5.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5846_30697",
    x1: 27.802,
    x2: 20.345,
    y1: 14.971,
    y2: 5.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5846_30697",
    x1: 27.802,
    x2: 20.275,
    y1: 14.971,
    y2: 4.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5846_30697",
    x1: 17.372,
    x2: 9.295,
    y1: 6.786,
    y2: 12.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_5846_30697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.35487 -5.47267 5.47262 .35487 16.932 1.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5846_30697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.321 10.006 -2.98)scale(2.6969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_5846_30697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.527 10.308 -2.825)scale(3.30275)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5846_30697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-41.92 10.67 -18.475)scale(2.59964)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_5846_30697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.33236 3.23533 -9.1224 9.39615 11.117 12.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#1E130E",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoFullLight);
export default ForwardRef;